import { ssoStatusResponseSchema, configureSSOBodySchema, disconnectSSOResponseSchema, } from '../contracts/sso-settings';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * Get the SSO status and SP credentials for an organization.
 * Returns the ACS URL, Entity ID, and Tenant ID needed to configure an Okta SAML app.
 *
 * Authorization: Owner or Manager only.
 */
export async function getOrgSSOStatus(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/settings/sso`);
    return parseSchema(ssoStatusResponseSchema, response);
}
/**
 * Initialize an empty SSO slot for an organization so the ssoId is available
 * before the customer has their Okta metadata URL. Idempotent.
 *
 * Authorization: Owner or Manager only.
 */
export async function initializeOrgSSO(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.post(`/organizations/${validatedId}/settings/sso/initialize`);
    return parseSchema(ssoStatusResponseSchema, response);
}
/**
 * Configure Okta SSO for an organization by submitting the Okta Metadata URL.
 * Kirin calls the Descope Management API to configure the SAML connection.
 * Returns the updated SSO status including the ACS URL.
 *
 * Authorization: Owner or Manager only (Session auth).
 */
export async function configureOrgSSO(client, organizationId, body) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedBody = parseSchema(configureSSOBodySchema, body);
    const response = await client.put(`/organizations/${validatedId}/settings/sso`, validatedBody);
    return parseSchema(ssoStatusResponseSchema, response);
}
/**
 * Disconnect SSO configuration for an organization.
 * Deletes the SSO slot in Descope and releases the associated email domain.
 * Idempotent - succeeds even if SSO is not configured.
 *
 * Authorization: Owner or Manager only (Session auth).
 */
export async function disconnectOrgSSO(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.delete(`/organizations/${validatedId}/settings/sso`);
    return parseSchema(disconnectSSOResponseSchema, response);
}
//# sourceMappingURL=sso-settings.js.map